import React, { useEffect, useRef, useState } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import GridData from '../../components/GridData/GridData';
import { useDispatch } from 'react-redux';
import { addNewItem, deleteItem, setSelectedItems, updateAllItems, updateItem, updateItemSearchParams, updateItemsLoadingStatus, updateItemsPagination, updateItemsSearch, useReturnAllItems } from './itemsSlice';
import ItemsApp, { IItemModel } from './ItemsApp';
import { Link, useMatch, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { addNewUser, useReturnAllUsers, useReturnCurrentUser } from '../user/userSlice';
import DynamicForm, { IDynamicForm, IDynamicFormElement } from '../../components/Form/DynamicForm';
import { addNewSection, updateSectionsSearchParams, useReturnAllSections } from '../sections/sectionsSlice';
import SectionsApp from '../sections/SectionsApp';
import UsersApp from '../user/UsersApp';
import { addNewBrand, useReturnAllBrands } from '../brands/brandsSlice';
import BrandsApp from '../brands/BrandsApp';
import { addNewWarehouse, useReturnAllWarehouses } from '../warehouses/warehousesSlice';
import WarehousesApp from '../warehouses/WarehousesApp';
import StatusChip from '../../components/StatusChip';
import GridDataCellWrapper from '../../components/GridData/GridDataCellWrapper';
import ShowContainedItemsButton from './ShowContainedItemsButton';
import CurrentItemLocation from './CurrentItemLocation';
import ContainerItemsModal from './ContainerItemsModal';
import { IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer';
import { IGridDataCellActionButton, IGridDataConfig, IGridHeaderOption, IModalObject } from '../../components/GridData';
import { ISearchParam } from '../BaseApp';
import ScanQRCode from './ScanQRCode';
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice';
import windowLocationRedirect from '../redirect';
import PrintSelectedItems from './PrintSelectedItems';
import ExportItems from './ExportItems';
import ItemCategory from './ItemCategory';
import PrintQrCodes from './PrintQrCodes';
import { handleCloseElementQuickPreview, handleOpenElementQuickPreview } from '../admin/adminPagesSlice';
import QuickSingleItemPreview from './QuickSingleItemPreview';
import ItemAdditionalData from './ItemAdditionalData';
import ItemAdditionalDataForm from './ItemAdditionalDataForm';
import { createOrUpdateElementData } from '../../components/Form/formsSlice';

// export const itemsListFilterFormDefaultElements: IDynamicFormElement[] = [
//     {
//         id: "status",
//         xs: 4,
//         type: "Select",
//         label: "Status",
//         fullWidth: true,
//         addNoneItem: true,
//         items: require('./ItemsApp').default.prototype.itemStatusList
//     },
//     {
//         id: "condition",
//         xs: 4,
//         type: "Select",
//         label: "Condition",
//         fullWidth: true,
//         addNoneItem: true,
//         items: require('./ItemsApp').default.prototype.itemConditions
//     },
//     {
//         id: "category_id",
//         xs: 4,
//         type: "SelectCategory",
//         label: "Category",
//         fullWidth: true,
//         displayForItem: true,
//         addNoneItem: true,
//     },
//     {
//         id: "warehouse_id",
//         xs: 4,
//         type: "DynamicModelSelect",
//         label: "Warehouse",
//         fullWidth: true,
//         appClass: new WarehousesApp(),
//         selectLabel: "Select Warehouse",
//         gridColumns: new WarehousesApp().gridDataColumns
//     },
//     {
//         id: "section_id",
//         xs: 4,
//         type: "DynamicModelSelect",
//         label: "Section",
//         fullWidth: true,
//         appClass: new SectionsApp(),
//         selectLabel: "Select Section",
//         gridColumns: new SectionsApp().gridDataColumns,
//         filterForm: new SectionsApp().gridConfig.filterForm
//     },
//     {
//         id: "brand_id",
//         xs: 4,
//         type: "DynamicModelSelect",
//         label: "Brand",
//         fullWidth: true,
//         appClass: new BrandsApp(),
//         selectLabel: "Select Brand",
//         gridColumns: new BrandsApp().gridDataColumns,
//         filterForm: new BrandsApp().gridConfig.filterForm
//     },
// ]

// export const itemsListFilterFormDefaultElements: IDynamicFormElement[] = []

interface IProps {
    customWarehouseId?: number,
    customLoading?: boolean,
    isInventoryPage?: boolean,
    disableRedirectAfterScan?: boolean,

    customItems?: IItemModel[],
    customPagination?: IDataDisplayerPagination,
    customSearch?: string,
    customSelectedItems?: IItemModel[],
    customSearchParams?: ISearchParam[],
    customGridDataConfig?: IGridDataConfig,
    customGridActionButtons?: IGridDataCellActionButton[]
    customGridHeaderOptions?: IGridHeaderOption[],

    customUpdateSearch?: (search: string) => void,
    customSetSelectedItems?: (items: IItemModel[]) => void,
    customDeleteItem?: (id: number) => void,
    customUpdateLoadingStatus?: (status: boolean) => void,
    customUpdateSearchParams?: (params: ISearchParam[]) => void,
    customAddNewItem?: (item: IItemModel) => void,
    customUpdateItem?: (item: IItemModel) => void,
    customUpdateAllItems?: (items: IItemModel[]) => void,
    customUpdatePagination?: (pagination: IDataDisplayerPagination) => void

    updateSearchParamsBeforeLoadItems?: (params: ISearchParam[]) => ISearchParam[],
    disableActionButton?: boolean,
    disableDelete?: boolean,
    disableRemoveEmptySearchParams?: boolean,
}

export default function ItemsList(props: IProps) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isCurrentPageAdminPanel = useMatch('/panel/*')

    const { 
        customWarehouseId, 
        customGridDataConfig, 
        customGridActionButtons,
        customGridHeaderOptions,
        isInventoryPage,
        disableRedirectAfterScan,
        updateSearchParamsBeforeLoadItems,
        disableActionButton,
        disableDelete,

        // Custom
        customItems,
        customPagination,
        customSearch,
        customSelectedItems,
        customSearchParams,
        customLoading,
        disableRemoveEmptySearchParams,

        // Custom functions
        customUpdateSearch,
        customSetSelectedItems,
        customDeleteItem,
        customUpdateLoadingStatus,
        customUpdateSearchParams,
        customAddNewItem,
        customUpdateItem,
        customUpdateAllItems,
        customUpdatePagination,
    } = props


    const { 
        items, 
        pagination, 
        loading, 
        search, 
        searchParams, 
        selectedItems, 
    } = useSelector((state: RootState) => state.items)
    const itemsApp = new ItemsApp()

    const currentUser = useReturnCurrentUser()

    const [showQrCodeScanner, setShowQrCodeScanner] = useState<boolean>(false)
    const [showItemsPrintPage, setShowItemsPrintPage] = useState<boolean>(false)
    const [showPrintQrCodesPage, setShowPrintQrCodesPage] = useState<boolean>(false)
    const [selectedCategoryTitle, setSelectedCategoryTitle] = useState<string>("")
    const [prevSelectedCategoryTitle, setPrevSelectedCategoryTitle] = useState<string>("")

    const [updatedSearchParamsFields, setUpdatedSearchParamsFields] = useState<string[]>([])

    const elementsData = DynamicForm.useReturnAllFormsData()

    /**
     * New updated field
     */
    const addUpdatedSearchParamsField = (id: string) => {
        setUpdatedSearchParamsFields(prev => 
            prev.includes(id) ? prev : [...prev, id]
        )
    }   

    /**
     * Remove updated field
     */
    const removeUpdatedSearchParamsField = (id: string) => {
        setUpdatedSearchParamsFields(prev => prev.filter(field => field !== id))
    }

    /**
     * Check if filter category_id is empty
     */
    const isFilterCategoryIdEmpty = () => {
        if (searchParams.find((param) => param.name === "category_id")){
            const findIndex = searchParams.findIndex((param) => param.name === "category_id")

            if (searchParams[findIndex]){
                if (searchParams[findIndex].value){
                    return true
                }else{
                    return false
                }
            }else{  
                return false
            }
        }else{
            return false
        }
    }

    /**
     * Update selectedCategoryTitle
     */
    useEffect(() => {

        if (!isFilterCategoryIdEmpty()){
            setSelectedCategoryTitle("")
        }

    }, [searchParams, selectedCategoryTitle])
    
    /**
     * Reset search params for addtional data
     */
    useEffect(() => {
        if (selectedCategoryTitle !== prevSelectedCategoryTitle){
            if (updatedSearchParamsFields.length > 0){
                /**
                 * Clear items search params
                 */
                let newSearchParams = [...searchParams]
                
                updatedSearchParamsFields.map((field) => {

                    const formattedName = field.replace(itemsApp.elemPrefix, "")

                    if (newSearchParams.find((param) => param.name === formattedName)){
                        newSearchParams = newSearchParams.filter(param => param.name !== formattedName)
                    }

                    dispatch(createOrUpdateElementData({
                        name: field,
                        value: null
                    }))
                })

                dispatch(updateItemSearchParams(newSearchParams))
            }
        }
    }, [selectedCategoryTitle, prevSelectedCategoryTitle])

    /**
     * Update loading status
     */
    const updateLoadingStatus = (status: boolean) => {
        if (customUpdateLoadingStatus){
            customUpdateLoadingStatus(status)
        }

        dispatch(updateItemsLoadingStatus({ loading: status }))
    }

    /**
     * Update Search
     */
    const updateSearch = (value: string) => {
        if (customUpdateSearch){
            customUpdateSearch(value)
        }

        dispatch(updateItemsSearch({ search: value }))
    }

    /**
     * Set selected items
     */
    const handleSetSelectedItems = (items: IItemModel[]) => {
        if (customSetSelectedItems){
            customSetSelectedItems(items)
        }

        dispatch(setSelectedItems(items))
    }

    /**
     * Handle delete item
     */
    const handleDeleteItem = (id: number) => {
        if (customDeleteItem){
            customDeleteItem(id)
        }

        dispatch(deleteItem({ id: id }))
    }

    /**
     * Filter
     */

    const filterFormElementsSuperUser: IDynamicFormElement[] = customWarehouseId ? [
        {
            id: "status",
            xs: 4,
            type: "Select",
            label: "Status",
            fullWidth: true,
            addNoneItem: true,
            items: new ItemsApp().itemStatusList
        },
        {
            id: "section_id",
            xs: 4,
            type: "DynamicSelect",
            label: "Section",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllSections,
            modelTitleParam: "title",
            appClass: new SectionsApp(),
            addNewItem: addNewSection,
            searchParams: [
                {
                    name: "warehouse_id",
                    value: customWarehouseId
                }
            ]
        },
        {
            id: "user_id",
            xs: 4,
            type: "DynamicSelect",
            label: "With User",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllUsers,
            modelTitleParam: "full_name",
            appClass: new UsersApp(),
            addNewItem: addNewUser,
        },
        {
            id: "category_id",
            xs: 6,
            type: "SelectCategory",
            label: "Category",
            fullWidth: true,
            displayForItem: true,
            addNoneItem: true,
        },
        {
            id: "brand_id",
            xs: 6,
            type: "DynamicSelect",
            label: "Brand",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllBrands,
            modelTitleParam: "title",
            appClass: new BrandsApp(),
            addNewItem: addNewBrand,
        },
    ] :[
        {
            id: "status",
            xs: 4,
            type: "Select",
            label: "Status",
            fullWidth: true,
            addNoneItem: true,
            items: new ItemsApp().itemStatusList
        },
        {
            id: "warehouse_id",
            xs: 4,
            type: "DynamicSelect",
            label: "Waerehouse",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllWarehouses,
            modelTitleParam: "title",
            appClass: new WarehousesApp(),
            addNewItem: addNewWarehouse,
        },
        {
            id: "section_id",
            xs: 4,
            type: "DynamicSelect",
            label: "Section",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllSections,
            modelTitleParam: "title",
            appClass: new SectionsApp(),
            addNewItem: addNewSection,
            filterBy: "warehouse_id"
            // searchParams: [
            //     {
            //         name: "warehouse_id",
            //         value: selectedWarehouseId
            //     }
            // ]
        },
        {
            id: "category_id",
            xs: 4,
            type: "SelectCategory",
            label: "Category",
            fullWidth: true,
            displayForItem: true,
            addNoneItem: true,
        },
        {
            id: "brand_id",
            xs: 4,
            type: "DynamicSelect",
            label: "Brand",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllBrands,
            modelTitleParam: "title",
            appClass: new BrandsApp(),
            addNewItem: addNewBrand,
        },
        {
            id: "user_id",
            xs: 4,
            type: "DynamicSelect",
            label: "With User",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllUsers,
            modelTitleParam: "full_name",
            appClass: new UsersApp(),
            addNewItem: addNewUser,
        },
    ]

    const filterFormElementsStaff: IDynamicFormElement[] = customWarehouseId ? [
        {
            id: "status",
            xs: 4,
            type: "Select",
            label: "Status",
            fullWidth: true,
            addNoneItem: true,
            items: new ItemsApp().itemStatusList
        },
        {
            id: "section_id",
            xs: 4,
            type: "DynamicSelect",
            label: "Section",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllSections,
            modelTitleParam: "title",
            appClass: new SectionsApp(),
            addNewItem: addNewSection,
            searchParams: [
                {
                    name: "warehouse_id",
                    value: customWarehouseId
                }
            ]
        },
        {
            id: "category_id",
            xs: 4,
            type: "SelectCategory",
            label: "Category",
            fullWidth: true,
            displayForItem: true,
            addNoneItem: true,
        },
    ] :[
        {
            id: "status",
            xs: 3,
            type: "Select",
            label: "Status",
            fullWidth: true,
            addNoneItem: true,
            items: new ItemsApp().itemStatusList
        },
        {
            id: "warehouse_id",
            xs: 3,
            type: "DynamicSelect",
            label: "Waerehouse",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllWarehouses,
            modelTitleParam: "title",
            appClass: new WarehousesApp(),
            addNewItem: addNewWarehouse,
        },
        {
            id: "section_id",
            xs: 3,
            type: "DynamicSelect",
            label: "Section",
            fullWidth: true,
            addNoneItem: true,
            itemsList: useReturnAllSections,
            modelTitleParam: "title",
            appClass: new SectionsApp(),
            addNewItem: addNewSection,
            filterBy: "warehouse_id"
            // searchParams: [
            //     {
            //         name: "warehouse_id",
            //         value: selectedWarehouseId
            //     }
            // ]
        },
        {
            id: "category_id",
            xs: 3,
            type: "SelectCategory",
            label: "Category",
            fullWidth: true,
            displayForItem: true,
            addNoneItem: true,
        },
    ]

    const [filterForm, setFilterForm] = useState<IDynamicForm>({
        name: "items-data-displayer-filter-form",
        // elements: currentUser.is_superuser ? filterFormElementsSuperUser : filterFormElementsStaff
        elements: itemsApp.itemsListFilterFormDefaultElements
    })

    /**
     * Header options
     */
    let gridHeaderOptions: IGridHeaderOption[] = []

    if (customGridHeaderOptions){
        gridHeaderOptions = [
            ...gridHeaderOptions,
            ...customGridHeaderOptions
        ]
    }

    gridHeaderOptions.push({
        label: "Scan",
        icon: "qrcode",
        onClick: () => setShowQrCodeScanner(showQrCodeScanner ? false : true),
    })

    gridHeaderOptions.push({
        label: "Export",
        icon: "download",
        onClick: () => {},
        customButton(selectedItems, updateFilterShowStatus, deleteItem, deleteManyItems, refresh, filterShownStatus) {
            
            return <ExportItems showQrCodesPrintPage={() => setShowPrintQrCodesPage(true)} showPrintPage={() => setShowItemsPrintPage(true)} selectedItems={(selectedItems as IItemModel[])} />
        },
    })

    /**
     * Handle scanned qr code
     */
    const handleScannedQrCode = (result: string) => {
        if (itemsApp.validateUniqueId(result)){

            // if (items.length > 0){

            //     let link: string = "panel/items/view/" + result
            //     let isFound: boolean = false

            //     items.map((item) => {
            //         if (item.unique_id === result){
            //             link = "panel/items/view/" + item.id
            //             isFound = true
            //         }
            //     })

            //     const inventoryPageLink: string = "items/" + result

            //     if (isInventoryPage || !isFound){
            //         link = inventoryPageLink
            //     }

            //     windowLocationRedirect(link)
            // }

            // dispatch(updateItemsSearch({ search: result }))

            let searchRes: string = ""

            if (search){
                searchRes = search + ", " + result
            }else{
                searchRes = result
            }

            if (disableRedirectAfterScan){
                dispatch(updateItemsSearch({ search: searchRes }))
            }else{
                windowLocationRedirect("panel/items/view/" + result)
            }

        }else{
            updateQuickNotificationDetails(true, "Unique ID is incorrect", "error", dispatch)
        }
    }

    /**
     * Items List
     */
    const renderItemsList = () => {
        return(
            <GridData 
                items={customItems ? customItems : items}
                columns={[
                    {
                        field: "title",
                        headerName: "Item",
                        type: "title",
                        width: 350,
                        minWidth: 350,
                        cellRendererParams: {
                            appClass: () => new ItemsApp(),
                            enableQuickPreview: true,
                            additionalContent: (data: IModalObject | null) => {
                                if (!data){
                                    return <></>
                                }

                                return(
                                    <div className="item-grid-data-cell-title-additional-data-container">
                                        <div className="content-of-item-grid-data-cell-title-additional-data-container">
                                            <ItemAdditionalData item={(data as IItemModel)} />
                                            {data.is_container ? <ShowContainedItemsButton item={(data as IItemModel)} /> : <></>}
                                        </div>
                                    </div>
                                )
                            }
                        }
                    },
                    // {
                    //     field: "thumbnail",
                    //     headerName: "Thumbnail",
                    //     type: "thumbnail",
                    //     resizable: false,
                    //     width: 110,
                    // },
                    // {
                    //     field: "title",
                    //     headerName: "Title",
                    //     minWidth: 300,
                    //     cellRenderer: (params: ICellRendererParams<IItemModel>) => {
                    //         const item = params.data

                    //         if (!item){
                    //             return params.value
                    //         }

                    //         const link = isCurrentPageAdminPanel ? `/panel/items/view/${item.unique_id}` : `/items/${item.unique_id}`

                    //         const handleQuickPreview = () => {
                    //             handleOpenElementQuickPreview(
                    //                     item.id,
                    //                     item.title,
                    //                     () => new ItemsApp(),
                    //                     dispatch,
                    //                     [
                    //                         {
                    //                             color: "success",
                    //                             label: "Open",
                    //                             onClick: () => {
                    //                                 handleCloseElementQuickPreview(dispatch)
                    //                                 navigate(link)
                    //                             },
                    //                             disabled: link ? false : true
                    //                         },
                    //                         {
                    //                             color: "error",
                    //                             label: "Close",
                    //                             onClick: () => handleCloseElementQuickPreview(dispatch)
                    //                         }
                    //                     ],
                    //                     true,
                    //                     (elementId) => {
                    //                         return <QuickSingleItemPreview itemId={elementId} />
                    //                     },
                    //                     true
                    //                 )
                    //         }

                    //         // return(
                    //         //     <div className="grid-data-current-item-location-box">
                    //         //         <Link className="data-grid-link" to={isCurrentPageAdminPanel ? `/panel/items/view/${item.unique_id}` : `/items/${item.unique_id}`}>
                    //         //             <h3 className="title">{item.title}</h3>
                    //         //         </Link>

                    //         //         {item.is_container && <ShowContainedItemsButton item={item} />}
                    //         //     </div>
                    //         // )
                    //         return(
                    //             <div className="grid-data-current-item-location-box">
                    //                 <h3 className="title" onClick={() => handleQuickPreview()} style={{ cursor: "pointer" }}>{item.title}</h3>

                    //                 {item.is_container && <ShowContainedItemsButton item={item} />}
                    //             </div>
                    //         )
                    //     }
                    // },
                    {
                        field: "status",
                        headerName: "Status",
                        width: 150,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) => {
                            const value = params.value
            
                            return(
                                <GridDataCellWrapper>
                                    <StatusChip type={value} />
                                </GridDataCellWrapper>
                            )
                        }
                    },
                    {
                        field: "condition",
                        headerName: "Condition",
                        width: 150,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) => {
                            const value = params.value
            
                            return(
                                <GridDataCellWrapper>
                                    <StatusChip type={value} />
                                </GridDataCellWrapper>
                            )
                        }
                    },
                    {
                        field: "is_container",
                        headerName: "Type",
                        width: 150,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) => {
                            const value = params.value
            
                            return(
                                <GridDataCellWrapper>
                                    <StatusChip type={value ? "container" : "regular"} />
                                </GridDataCellWrapper>
                            )
                        }
                    },
                    {
                        field: "warehouse_id",
                        headerName: "Location",
                        minWidth: 300,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) => {
                            const item = params.data
            
                            if (!item){
                                return "-"
                            }
            
                            return(
                                <div className="grid-data-current-item-location-box">
                                    <CurrentItemLocation item={item} />
                                </div>
                            )
                        }
                    },
                    {
                        field: "brand_title",
                        headerName: "Brand",
                        type: "quick-preview",
                        width: 200,
                        minWidth: 200,
                        cellRendererParams: {
                            appClass: () => new BrandsApp(),
                            elemIdTitle: "brand_id"
                        }
                    },
                    {
                        field: "category_title",
                        headerName: "Category",
                        width: 250,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) => {
                            const item = params.data

                            if (!item){
                                return "-"
                            }

                            return <ItemCategory item={item} />
                        }
                    },
                    {
                        field: "available_quantity",
                        headerName: "Available Qnt.",
                        maxWidth: 130,
                        minWidth: 130,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) =>{

                            return params.value ? params.value : 0
                        }
                    },
                    // {
                    //     field: "quantity",
                    //     headerName: "Item Qnt.",
                    //     maxWidth: 130,
                    //     minWidth: 130,
                    // },
                    {
                        field: "reserved",
                        headerName: "Reserved Qnt.",
                        maxWidth: 130,
                        minWidth: 130,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) =>{

                            return params.value ? params.value : 0
                        }
                    },
                    {
                        field: "damaged",
                        headerName: "Damaged Qnt.",
                        maxWidth: 130,
                        minWidth: 130,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) =>{

                            return params.value ? params.value : 0
                        }
                    },
                    {
                        field: "missing",
                        headerName: "Missing Qnt.",
                        maxWidth: 130,
                        minWidth: 130,
                        cellRenderer: (params: ICellRendererParams<IItemModel>) =>{

                            return params.value ? params.value : 0
                        }
                    },
                    {
                        field: "unique_id",
                        headerName: "Unique ID"
                    },
                    {
                        field: "serial_number",
                        headerName: "Serial Number"
                    },
                    {
                        field: "created_by_name",
                        headerName: "Created by",
                        type: "quick-preview",
                        cellRendererParams: {
                            appClass: () => new UsersApp(),
                            elemIdTitle: "created_by"
                        }
                    },
                    {
                        field: "date_created",
                        headerName: "Date Created",
                        type: "date",
                        minWidth: 230
                    },
                ]}
                selectedItems={customSelectedItems ? customSelectedItems : selectedItems}
                pagination={customPagination ? customPagination : pagination}
                search={customSearch ? customSearch : search ? search : ""}
                searchParams={customSearchParams ? customSearchParams : searchParams}
                loading={customLoading ? customLoading : loading}
                actionButtons={customGridActionButtons ? customGridActionButtons :[]}
                headerOptions={gridHeaderOptions}
                handleLoadItems={itemsApp.listOfInstances}
                updateSearch={updateSearch}
                setSelectedItems={(items) => handleSetSelectedItems(items as IItemModel[])}
                onDeleteItem={itemsApp.deleteInstance}
                onDeleteManyItems={itemsApp.deleteManyInstances}
                deleteItem={(id, dispatch) => handleDeleteItem(id)}
                updateLoading={updateLoadingStatus}
                updateItemSearchParams={(params) => {
                    console.log("ItemsList.tsx updateItemSearchParams ->", params)
                    customUpdateSearchParams ? customUpdateSearchParams(params) : dispatch(updateItemSearchParams(params))
                }}
                addNewItem={(item, dispatch) => customAddNewItem ? customAddNewItem((item as IItemModel)) : dispatch(addNewItem((item as IItemModel)))}
                updateItem={(item, dispatch) => {
                    if (customUpdateItem){
                        console.log("customUpdateItem")
                        customUpdateItem((item as IItemModel))
                    }else{
                        console.log('dispatch(updateItem')
                        dispatch(updateItem((item as IItemModel)))
                    }
                }}
                updateAllItems={(items, dispatch) => {
                    if (customUpdateAllItems){
                        console.log("customUpdateAllItems")
                        customUpdateAllItems((items as IItemModel[]))
                    }else{
                        console.log('dispatch(updateAllItems')
                        dispatch(updateAllItems((items as IItemModel[])))
                    }
                }}
                updateItemsPagination={(pagination, dispatch) => customUpdatePagination ? customUpdatePagination(pagination) :dispatch(updateItemsPagination(pagination))}
                config={customGridDataConfig ? customGridDataConfig :{
                    viewItemLink: isCurrentPageAdminPanel ? "/panel/items/view/[unique_id]" : "/items/[unique_id]",
                    editItemLink: "/panel/items/edit/[id]",
                    filterForm: filterForm,
                    disableActionButtons: disableActionButton,
                    disableDelete: disableDelete,
                    disableRemoveEmptySearchParams: disableRemoveEmptySearchParams
                }}
                updateSearchParamsBeforeLoadItems={updateSearchParamsBeforeLoadItems}
                /**
                 * Additional data filter
                 */
                addAdditionalFilters={(searchParams, updateItemSearchParams) => {

                    const findCategoryFilter = searchParams.find((p) => p.name === "category_id")

                    const customHandleOnChange = (id: string, value: any) => {

                        let newId: string = id.replace(itemsApp.elemPrefix, "")
                       
                        /**
                         * Update search params
                         */
                        let newSearchParams = [...searchParams]

                        const findParam = newSearchParams.find((param) => param.name === newId)

                        if (findParam){
                            const findIndex = newSearchParams.findIndex((param) => param.name === newId)

                            if (newSearchParams[findIndex]){
                                newSearchParams[findIndex] = {
                                    ...newSearchParams[findIndex],
                                    value: value
                                }
                            }
                        }else{
                            newSearchParams = [
                                ...newSearchParams,
                                {
                                    name: newId,
                                    value: value
                                }
                            ]
                        }

                        updateItemSearchParams(newSearchParams)

                        /**
                         * Update ItemAdditionalDataForm data
                         */
                        dispatch(createOrUpdateElementData({
                            name: id,
                            value: value
                        }))

                        addUpdatedSearchParamsField(id)

                    }

                    // if (!findCategoryFilter || !findCategoryFilter.value){
                    //     return <></>
                    // }

                    return <ItemAdditionalDataForm item={null} handleUpdateSubmitCategoryTitle={(title) => {
                        setSelectedCategoryTitle(title)
                        setPrevSelectedCategoryTitle(title)
                    }} customHandleOnChange={customHandleOnChange} customCategoryIdFieldName="category_id" />
                }}
            />
        )
    }

    /**
     * Render page content 
     */
    const renderPageContent = () => {
        
        if (showItemsPrintPage){
            return(
                <PrintSelectedItems selectedItems={selectedItems} goBack={() => {
                    setShowItemsPrintPage(false)
                    dispatch(setSelectedItems([]))
                }} />
            )
        }

        if (showPrintQrCodesPage){
            return(
                <PrintQrCodes items={selectedItems} goBack={() => {
                    setShowPrintQrCodesPage(false)
                    dispatch(setSelectedItems([]))
                }} />
            )
        }

        return renderItemsList()
    }

    return(
        <div>
            <ContainerItemsModal />
            <ScanQRCode shown={showQrCodeScanner} handleDecodedText={handleScannedQrCode} handleClose={() => setShowQrCodeScanner(false)} />
            
            {renderPageContent()}

        </div>
    )
}